'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var PeerId = require('peer-id');

var _require = require('multiformats/bases/base58'),
    base58btc = _require.base58btc;

var _require2 = require('p-queue'),
    PQueue = _require2.default;

var defer = require('p-defer');

var debug = require('debug');

var log = debug('libp2p-delegated-peer-routing');
log.error = debug('libp2p-delegated-peer-routing:error');
var DEFAULT_TIMEOUT = 30e3; // 30 second default

var CONCURRENT_HTTP_REQUESTS = 4;

var DelegatedPeerRouting = /*#__PURE__*/function () {
  /**
   * Create a new DelegatedPeerRouting instance.
   *
   * @param {object} client - an instance of the ipfs-http-client module
   */
  function DelegatedPeerRouting(client) {
    _classCallCheck(this, DelegatedPeerRouting);

    if (client == null) {
      throw new Error('missing ipfs http client');
    }

    this._client = client; // limit concurrency to avoid request flood in web browser
    // https://github.com/libp2p/js-libp2p-delegated-content-routing/issues/12

    this._httpQueue = new PQueue({
      concurrency: CONCURRENT_HTTP_REQUESTS
    });

    var _client$getEndpointCo = client.getEndpointConfig(),
        protocol = _client$getEndpointCo.protocol,
        host = _client$getEndpointCo.host,
        port = _client$getEndpointCo.port;

    log("enabled DelegatedPeerRouting via ".concat(protocol, "://").concat(host, ":").concat(port));
  }
  /**
   * Attempts to find the given peer
   *
   * @param {PeerID} id
   * @param {object} options
   * @param {number} options.timeout - How long the query can take. Defaults to 30 seconds
   * @returns {Promise<{ id: PeerId, multiaddrs: Multiaddr[] }>}
   */


  _createClass(DelegatedPeerRouting, [{
    key: "findPeer",
    value: function () {
      var _findPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var _this2 = this;

        var options,
            idStr,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                idStr = id;

                if (PeerId.isPeerId(idStr)) {
                  idStr = id.toB58String();
                }

                log('findPeer starts: ' + id);
                options.timeout = options.timeout || DEFAULT_TIMEOUT;
                _context2.prev = 5;
                _context2.next = 8;
                return this._httpQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _yield$_this2$_client, addrs;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this2._client.dht.findPeer(idStr, {
                            timeout: options.timeout
                          });

                        case 2:
                          _yield$_this2$_client = _context.sent;
                          addrs = _yield$_this2$_client.addrs;
                          return _context.abrupt("return", {
                            id: id,
                            multiaddrs: addrs
                          });

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 8:
                return _context2.abrupt("return", _context2.sent);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](5);

                if (!_context2.t0.message.includes('not found')) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", undefined);

              case 15:
                throw _context2.t0;

              case 16:
                _context2.prev = 16;
                log('findPeer finished: ' + id);
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11, 16, 19]]);
      }));

      function findPeer(_x) {
        return _findPeer.apply(this, arguments);
      }

      return findPeer;
    }()
    /**
     * Attempt to find the closest peers on the network to the given key
     *
     * @param {Uint8Array} key - A CID like key
     * @param {object} [options]
     * @param {number} [options.timeout=30e3] - How long the query can take.
     * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>}
     */

  }, {
    key: "getClosestPeers",
    value: function getClosestPeers(key) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var keyStr, onStart, onFinish, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                keyStr = base58btc.encode(key).substring(1);
                log('getClosestPeers starts:', keyStr);
                options.timeout = options.timeout || DEFAULT_TIMEOUT;
                onStart = defer();
                onFinish = defer();

                _this._httpQueue.add(function () {
                  onStart.resolve();
                  return onFinish.promise;
                });

                _context4.prev = 6;
                return _context4.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var peers, result;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _awaitAsyncGenerator(onStart.promise);

                        case 2:
                          peers = new Map();
                          _iteratorAbruptCompletion = false;
                          _didIteratorError = false;
                          _context3.prev = 5;
                          _iterator = _asyncIterator(_this._client.dht.query(keyStr, {
                            timeout: options.timeout
                          }));

                        case 7:
                          _context3.next = 9;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 9:
                          if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                            _context3.next = 23;
                            break;
                          }

                          result = _step.value;
                          _context3.t0 = result.type;
                          _context3.next = _context3.t0 === 1 ? 14 : _context3.t0 === 2 ? 16 : 19;
                          break;

                        case 14:
                          // Found Closer
                          // Track the addresses, so we can yield them when done
                          result.responses.forEach(function (response) {
                            peers.set(response.id, {
                              id: PeerId.parse(response.id),
                              multiaddrs: response.addrs
                            });
                          });
                          return _context3.abrupt("break", 20);

                        case 16:
                          _context3.next = 18;
                          return peers.get(result.id.string) || {
                            id: PeerId.createFromCID(result.id),
                            multiaddrs: []
                          };

                        case 18:
                          return _context3.abrupt("break", 20);

                        case 19:
                          log('getClosestPeers unhandled response', result);

                        case 20:
                          _iteratorAbruptCompletion = false;
                          _context3.next = 7;
                          break;

                        case 23:
                          _context3.next = 29;
                          break;

                        case 25:
                          _context3.prev = 25;
                          _context3.t1 = _context3["catch"](5);
                          _didIteratorError = true;
                          _iteratorError = _context3.t1;

                        case 29:
                          _context3.prev = 29;
                          _context3.prev = 30;

                          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                            _context3.next = 34;
                            break;
                          }

                          _context3.next = 34;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 34:
                          _context3.prev = 34;

                          if (!_didIteratorError) {
                            _context3.next = 37;
                            break;
                          }

                          throw _iteratorError;

                        case 37:
                          return _context3.finish(34);

                        case 38:
                          return _context3.finish(29);

                        case 39:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[5, 25, 29, 39], [30,, 34, 38]]);
                })(), "t0", 8);

              case 8:
                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t1 = _context4["catch"](6);
                log.error('getClosestPeers errored:', _context4.t1);
                throw _context4.t1;

              case 14:
                _context4.prev = 14;
                onFinish.resolve();
                log('getClosestPeers finished:', keyStr);
                return _context4.finish(14);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[6, 10, 14, 18]]);
      }))();
    }
  }]);

  return DelegatedPeerRouting;
}();

module.exports = DelegatedPeerRouting;